import React, { useState } from 'react';
import { FaAccessibleIcon } from "react-icons/fa";
import {
    Button,
    Form,
    FormGroup,
    Label,
    Input,
  } from 'reactstrap';

 
   

const OtpPass = () => {

    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });

    const handleChange = (e) => {
        setFormData({
          ...formData,
          [e.target.name]: e.target.value,
        });
      };

    const handleSubmit = (e) => {
        e.preventDefault();
        //Console.log(formData);
    };
    
  return (
    <Form onSubmit={handleSubmit} className='Login'>
      <div className="login-head">
        <FaAccessibleIcon size={30} color="green" />
        <p>Sales Ehub</p>
      </div>
        <FormGroup>
          <Label for="exampleEmail">Provide the otp sent to your email for a Password Reset</Label>
          <Input
            type="password"
            name="otp"
            id="otp"
            placeholder="123456"
            value={formData.otp}
            onChange={handleChange}
          />
        </FormGroup>
    <div className="login-footer">
      <Button type="submit" className='login-btn'>
        Change Password
      </Button>
      <a href="/forgot-password" className="forgot-password">
        Return to Login
      </a>
  </div>
  </Form>
  )
}

export default OtpPass